import * as React from 'react'
interface AuthProps {
    name: string,
    city: string,
    userName: string,
    designation: string,
}

const AuthProfile: React.FC<any> = (props: AuthProps) => {
    React.useEffect(() => {
        // name = userSelector.getName(store.auth)
        // nameFromStateHandler(name)
    }, [props.name])

    let name, phone
    // name = userSelector.getName(store.auth)
    // phone = userSelector.getPhone(store.auth)
    // const { email, designation } = userSelector.getExtras(store.auth)

    return (
        <div>
            <label>Name:</label>{name}<br />
            {/* <label>Email:</label>{email}<br /> */}
            {/* <label>Designation:</label>{designation}<br /> */}
            <label>Phone:</label>{phone}<br />
        </div>
    )
}

export default AuthProfile
